export var RewardTypeType;
(function (RewardTypeType) {
    /** Unknown reward type. */
    RewardTypeType["UNKNOWN"] = "UNKNOWN";
    /** Loyalty coupon is given. */
    RewardTypeType["COUPON"] = "COUPON";
    /** Loyalty points are awarded. */
    RewardTypeType["LOYALTY_POINTS"] = "LOYALTY_POINTS";
    /** No reward is given. */
    RewardTypeType["NOTHING"] = "NOTHING";
})(RewardTypeType || (RewardTypeType = {}));
export var CouponStatusStatus;
(function (CouponStatusStatus) {
    /** Coupon status is unknown or not specified. */
    CouponStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** Coupon is active and can be applied to purchases. */
    CouponStatusStatus["ACTIVE"] = "ACTIVE";
    /** Coupon was applied and can't be used again. */
    CouponStatusStatus["APPLIED"] = "APPLIED";
    /** Coupon was deleted and is no longer valid. */
    CouponStatusStatus["DELETED"] = "DELETED";
})(CouponStatusStatus || (CouponStatusStatus = {}));
export var DiscountType;
(function (DiscountType) {
    /** Unknown discount type. */
    DiscountType["UNKNOWN"] = "UNKNOWN";
    /** Discount as a fixed amount. */
    DiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    /** Discount as a percentage. */
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
    /** Free shipping. If `true`, the coupon applies to all items in all `namespaces`. */
    DiscountType["FREE_SHIPPING"] = "FREE_SHIPPING";
})(DiscountType || (DiscountType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Type;
(function (Type) {
    /** Unknown reward type. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** Coupon reward type. */
    Type["COUPON"] = "COUPON";
    /** Loyalty points reward type. */
    Type["LOYALTY_POINTS"] = "LOYALTY_POINTS";
    /** No reward type. */
    Type["NOTHING"] = "NOTHING";
})(Type || (Type = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map